export default "__VITE_ASSET__W7Fp7jH3__"